import { defineMessages } from "react-intl";

export default defineMessages({
  ringtwice_plus_advantage_one_closure: {
    id: "advantages.ringtwice_plus_advantage_one_closure",
    defaultMessage:
      "<bold>0% de frais de gestion</bold> au lieu de 20% sur tous vos services",
  },
  ringtwice_plus_advantage_two_closure: {
    id: "advantages.ringtwice_plus_advantage_two_closure",
    defaultMessage: "<bold>Garantie: Satisfait</bold> ou refait",
  },
  cancelForFree: {
    id: "subscriptionAdvantage.cancelForFree",
    defaultMessage: "<bold>Cancel anytime,</bold> no strings attached.",
  },
  ringtwice_plus_advantage_four_closure: {
    id: "advantages.ringtwice_plus_advantage_four_closure",
    defaultMessage:
      "Un pépin ? Pas de stress, notre <bold>assurance AXA</bold> vous couvre",
  },
});
